import { Card } from "../card";
import { Protocol } from "../../protocol";

export class OrderCardDTO {
  constructor(private readonly card: Card, private readonly protocol: Protocol) {}

  getCard(): Card {
    return this.card;
  }

  getProtocol(): Protocol {
    return this.protocol;
  }
}
